export default () => ({
  availability: {
    availableForStudent: false,
    hasParent: false,
  },
})
